/**
 * @desc 根据交易主体编码列表获取主体信息列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.OrderCompanyRpcResponseDto>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/ordercompany/listByCodes`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
